import styled from 'styled-components';
import theme from 'src/theme/Theme';

export const tcmEncounterStyle = {
  display: 'flex',
  flexDirection: 'row',
  overflowX: 'hidden',
  flex: 1,
  justifyContent: 'flex-end',
};

export const EncounterTimelineOpenCloseIcon = styled.img`
  width: 30px;
  height: 30px;
  cursor: pointer;
  padding: 2px 6px;
  margin: 12px -6px 0 -15px;
  position: ${props => (props.isOpen ? 'absolute' : 'absolute')};
  right: ${props => (props.isOpen ? '210px' : '0px')};
  top: 0;
  border-bottom-left-radius: 50%;
  border-top-left-radius: 50%;
  background-color: ${theme.colors.ICON_BACKGROUND_COLOR_LIGHT};
  z-index: 0;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
`;
